import { ConnectionAccessibilityEnum, ConnectionTypeEnum, EdgeEnclosureEnum, PiercingEnum } from '../enums/dismountability.enum';

export function getConnectionTypes() {
    return [
        {
            label: ConnectionTypeEnum.DrogeVerbinding,
            id: 1,
            score: 1.00,
            helpText: 'los of klik-, klitteband-, magnetische verbinding'
        },
        {
            label: ConnectionTypeEnum.VerbindingMetToegevoegdeElementen,
            id: 2,
            score: 0.80,
            helpText: 'bout- en moer-, veer-, hoek-, schroefverbinding'
        },
        {
            label: ConnectionTypeEnum.DirecteIntegraleVerbinding,
            id: 3,
            score: 0.60,
            helpText: 'pin-, spijkerverbinding'
        },
        {
            label: ConnectionTypeEnum.ZachteChemischeVerbinding,
            id: 4,
            score: 0.20,
            helpText: 'kit-, schuimverbinding (PUR)'
        },
        {
            label: ConnectionTypeEnum.HardeChemischeVerbinding,
            id: 5,
            score: 0.10,
            helpText: 'chemische ankers of lijm-, aanstorting-, las-, cementgebonden verbinding'
        }
    ];
}

export function getConnectionAccessibility() {
    return [
        {
            label: ConnectionAccessibilityEnum.FreeAccessWithoutActions,
            id: 1,
            score: 1.00,
            helpText: ''
        },
        {
            label: ConnectionAccessibilityEnum.AccessibleWithNoHarmfulActions,
            id: 2,
            score: 0.80,
            helpText: ''
        },
        {
            label: ConnectionAccessibilityEnum.AccessibleWithFullyRestorableDamage,
            id: 3,
            score: 0.60,
            helpText: ''
        },
        {
            label: ConnectionAccessibilityEnum.AccessibleWithPartiallyRestorableDamage,
            id: 4,
            score: 0.40,
            helpText: ''
        },
        {
            label: ConnectionAccessibilityEnum.NotAccessibleUnrecoverableDamage,
            id: 5,
            score: 0.10,
            helpText: ''
        }
    ];
}

export function getPiercing() {
    return [
        {
            label: PiercingEnum.NoCrossings,
            id: 1,
            score: 1.00,
            helpText: ''
        },
        {
            label: PiercingEnum.IncidentalCrossings,
            id: 2,
            score: 0.40,
            helpText: ''
        },
        {
            label: PiercingEnum.FullIntegration,
            id: 3,
            score: 0.10,
            helpText: ''
        }
    ];
}

export function getEdgeEnclosure() {
    return [
        {
            label: EdgeEnclosureEnum.OpenNoObstruction,
            id: 1,
            score: 1.00,
            helpText: ''
        },
        {
            label: EdgeEnclosureEnum.PartialObstruction,
            id: 2,
            score: 0.40,
            helpText: ''
        },
        {
            label: EdgeEnclosureEnum.ClosedCompleteObstruction,
            id: 3,
            score: 0.10,
            helpText: ''
        }
    ];
}
